import { useState } from 'react'
import PropTypes from 'prop-types'

import ModalFrame from 'common/components/ModalFrame'
import Spinner from 'common/components/Spinner'

import styles from './RenameDeviceModal.module.scss'

const getTrimmedName = name => String(name || '').trim()

const RenameDeviceModal = ({ currentName, deviceIdLabel, hideModal, onConfirm }) => {
  const [newName, setNewName] = useState(currentName || '')
  const [isConfirming, setIsConfirming] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const trimmedName = getTrimmedName(newName)
  const currentTrimmedName = getTrimmedName(currentName || '')
  const isInvalidName = !trimmedName || trimmedName === currentTrimmedName

  const handleSubmitName = event => {
    event.preventDefault()

    if (!isInvalidName) {
      setIsConfirming(true)
    }
  }

  const handleConfirm = () => {
    if (isInvalidName || isSubmitting) return

    setIsSubmitting(true)
    onConfirm(trimmedName, isSuccess => {
      setIsSubmitting(false)

      if (isSuccess) {
        hideModal()
      }
    })
  }

  const renderInputStep = () => (
    <form onSubmit={handleSubmitName}>
      <h2 className={styles.title}>Cambiar nombre</h2>
      <p className={styles.message}>
        Introduce el nuevo nombre para el dispositivo{' '}
        <strong>
          {currentName || '-'} (id: {deviceIdLabel})
        </strong>
        .
      </p>
      <label
        className={styles.label}
        htmlFor='rename-device-name'
      >
        Nuevo nombre
      </label>
      <input
        autoFocus
        className={styles.input}
        disabled={isSubmitting}
        id='rename-device-name'
        onChange={event => setNewName(event.target.value)}
        type='text'
        value={newName}
      />
      <div className={styles.actions}>
        <button
          className={styles.cancelButton}
          onClick={hideModal}
          type='button'
        >
          CANCELAR
        </button>
        <button
          className={styles.confirmButton}
          disabled={isInvalidName}
          type='submit'
        >
          CONTINUAR
        </button>
      </div>
    </form>
  )

  const renderConfirmStep = () => (
    <>
      <h2 className={styles.title}>Aviso</h2>
      <p className={styles.message}>
        ¿Estás seguro que quieres cambiar el nombre del dispositivo{' '}
        <strong>
          {currentName || '-'} (id: {deviceIdLabel})
        </strong>{' '}
        a <strong>{trimmedName}</strong>?
      </p>
      <div className={styles.actions}>
        <button
          className={styles.cancelButton}
          disabled={isSubmitting}
          onClick={hideModal}
          type='button'
        >
          CANCELAR
        </button>
        <button
          className={styles.confirmButton}
          disabled={isInvalidName || isSubmitting}
          onClick={handleConfirm}
          type='button'
        >
          {isSubmitting ? (
            <Spinner
              size={18}
              tone='white'
            />
          ) : (
            'CAMBIAR'
          )}
        </button>
      </div>
    </>
  )

  return (
    <ModalFrame
      className={styles.modal}
      hideModal={hideModal}
      isSubmitting={isSubmitting}
      scrollable
    >
      {isConfirming ? renderConfirmStep() : renderInputStep()}
    </ModalFrame>
  )
}

RenameDeviceModal.propTypes = {
  currentName: PropTypes.string,
  deviceIdLabel: PropTypes.string.isRequired,
  hideModal: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
}

RenameDeviceModal.defaultProps = {
  currentName: ''
}

export default RenameDeviceModal
